import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogComponent, DialogConfiguration, DialogService, FilterPipe, ToastmessageService } from '@prekog/common-ui';
import { Examination } from './examination';
import { GetSpecialityRequest } from './getspecialityrequest';
import { GetSpecialityResponse } from './getspecialityresponse';
import { DeleteExaminationByIdRequest } from './models/deleteexaminationbyidrequest';
import { UpdatePriceListRequest } from './updatepricelistrequest';

@Component({
    selector: 'app-pricelist',
    templateUrl: './pricelist.component.html',
    styleUrls: ['./pricelist.component.scss'],
    standalone: true,
    imports: [MatIconModule, ReactiveFormsModule, CommonModule, RouterModule, DragDropModule, FormsModule, FilterPipe]
})
export class PricelistComponent implements OnInit {
    deleteExaminationByIdUrl = '/admin/delete-examination-by-id';
    examinationList?: Examination[];
    getSpecialityByRouterLinkUrl = '/regenero/get-speciality-by-routerLink';
    priceListForm?: FormGroup;
    regeneroBaseUrl = '';
    routerLink = '';
    searchText = '';
    specialityName = '';
    updatePriceListUrl = '/admin/update-pricelist';

    get items(): FormArray {
        return this.priceListForm?.get('items') as FormArray;
    }
    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private fb: FormBuilder,
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
        this.createPriceListFormArray();
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            const lastSegmentOfUrl = window.location.href.split('/').pop();
            this.routerLink = lastSegmentOfUrl as string;
            this.getSpecialityByRouterLink();
        }
    }

    createPriceListFormArray(): void {
        this.priceListForm = this.fb.group({
            items: this.fb.array([])
        });
    }

    updatePriceList(): void {
        const examinationList = this.items.value as Examination[];
        examinationList.forEach((examination) => {
            this.examinationList?.forEach((examination2, index) => {
                if (examination.id === examination2.id) {
                    examination2.maxPrice = examination.maxPrice;
                    examination2.minPrice = examination.minPrice;
                    examination2.price = examination.price;
                    examination2.name = examination.name;
                    examination2.orderNumber = index;
                    examination2.specialityId = examination.specialityId;
                }
            });
        });

        const updatePriceListRequest: UpdatePriceListRequest = {
            examinationList: this.examinationList
        };

        this._apiRequestService
            .sendRequest<
                UpdatePriceListRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, updatePriceListRequest, true, this.updatePriceListUrl, true)
            .subscribe();
    }

    getSpecialityByRouterLink(): void {
        const getspecialitybyidRequest: GetSpecialityRequest = {
            routerLink: this.routerLink
        };
        this._apiRequestService
            .sendRequest<
                GetSpecialityRequest,
                GetSpecialityResponse
            >(this.regeneroBaseUrl, getspecialitybyidRequest, true, this.getSpecialityByRouterLinkUrl)
            .subscribe((response) => {
                this.specialityName = response.speciality?.name as string;
                this.examinationList = response.speciality?.examinationList;
                this.priceListForm = this.fb.group({
                    items: this.fb.array(this.examinationList!.map((examination) => this.fb.group(examination)))
                });
            });
    }

    openDeleteExaminationDialog(examinationId: number): void {
        const examinationName = this.examinationList?.find((examination) => examination.id === examinationId)?.name ?? '';
        const dialogConfiguration: DialogConfiguration = {
            messageKey: 'examination.deleteConfirmMessage',
            targetData: examinationName
        };

        this._dialogService.openDialog(DialogComponent, dialogConfiguration, () => this._deleteExamination(examinationId));
    }

    private _deleteExamination(examinationId: number): void {
        const deleteExaminationByIdRequest: DeleteExaminationByIdRequest = {
            examinationId: examinationId
        };

        this._apiRequestService
            .sendRequest<
                DeleteExaminationByIdRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, deleteExaminationByIdRequest, true, this.deleteExaminationByIdUrl, true)
            .subscribe(() => {
                this.examinationList = this.examinationList?.filter((existingExamination) => existingExamination.id !== examinationId);
            });
    }

    drop(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.examinationList!, event.previousIndex, event.currentIndex);
    }
}
